import { z } from 'zod';
import { getBaseOasisValidationSchema } from '../../oasis';
// eslint-disable-next-line
export const sectionNSkipPatterns = ({ input, ctx, isSection, field }) => {
    const schema = getBaseOasisValidationSchema('e1', 'soc'); // args here doesn't have a purpose
    if (!isSection && !field) {
        // form level
        // eslint-disable-next-line
        const payload = input;
    }
    else if (!field) {
        // section level
        const payload = input;
        // N-skip pattern-4421 If M2001_DRUG_RGMN_RVW=[0], then M2003_MDCTN_FLWP must equal [^].
        if (payload?.m2001 === '0' && payload.m2003) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-4421 If M2001 = 0, then M2003_MDCTN_FLWP must be empty.`,
                path: ['m2003'],
            });
        }
        // N-skip pattern-4431 If M2001_DRUG_RGMN_RVW=[1], then all active items from M2003_MDCTN_FLWP through M2030_CRNT_MGMT_INJCTN_MDCTN must not equal [^].
        if (payload?.m2001 === '1' && (!payload.m2003 || !payload.m2010 || !payload.m2020 || !payload.m2030)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-4431 If M2001 = 1, then all items from M2003 through M2030 must NOT be empty`,
                path: ['m2001'],
            });
        }
        // N-skip pattern-4441 If M2001_DRUG_RGMN_RVW=[9], then all active items from M2003_MDCTN_FLWP through M2030_CRNT_MGMT_INJCTN_MDCTN must equal [^].
        if (payload?.m2001 === '9' && (payload.m2003 || payload.m2010 || payload.m2020 || payload.m2030)) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-4441 If M2001 = 9, then all items from M2003 through M2030 must be empty.`,
                path: ['m2001'],
            });
        }
        // N-skip pattern-5490 If M2001_DRUG_RGMN_RVW=[0], then M2010_HIGH_RISK_DRUG_EDCTN must not equal [^].
        if (payload?.m2001 === '0' && !payload.m2010) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-5490 If M2001 = 0, then M2010 must NOT be empty.`,
                path: ['m2010'],
            });
        }
        // N-skip pattern-5960 (a) If N0415A1=[0], then N0415A2 must equal [^].
        if (payload?.n0415?.n0415a1 === false && payload.n0415.n0415a2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-5960 (a) If N0415A1 is NOT checked, then N0415A2 must also NOT be checked.`,
                path: ['n0415'],
            });
        }
        // N-skip pattern-5970 (a) If N0415E1=[0], then N0415E2 must equal [^].
        if (payload?.n0415?.n0415e1 === false && payload.n0415.n0415e2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-5970 (a) If N0415E1 is NOT checked, then N0415E2 must also NOT be checked.`,
                path: ['n0415'],
            });
        }
        // N-skip pattern-5980 (a) If N0415F1=[0], then N0415F2 must equal [^].
        if (payload?.n0415?.n0415f1 === false && payload.n0415.n0415f2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-5970 (a) If N0415F1 is NOT checked, then N0415F2 must also NOT be checked.`,
                path: ['n0415'],
            });
        }
        // N-skip pattern-5990 (a) If N0415H1=[0], then N0415H2 must equal [^].
        if (payload?.n0415?.n0415h1 === false && payload.n0415.n0415h2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-5970 (a) If N0415H1 is NOT checked, then N0415H2 must also NOT be checked.`,
                path: ['n0415'],
            });
        }
        // N-skip pattern-6000 (a) If N0415I1=[0], then N0415I2 must equal [^].
        if (payload?.n0415?.n0415i1 === false && payload.n0415.n0415i2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-5970 (a) If N0415I1 is NOT checked, then N0415I2 must also NOT be checked.`,
                path: ['n0415'],
            });
        }
        // N-skip pattern-6010 (a) If N0415J1=[0], then N0415J2 must equal [^].
        if (payload?.n0415?.n0415j1 === false && payload.n0415.n0415j2) {
            ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: `-5970 (a) If N0415J1 is NOT checked, then N0415J2 must also NOT be checked.`,
                path: ['n0415'],
            });
        }
    }
    else {
        // field level
    }
};
// N-skip pattern-4421 If M2001_DRUG_RGMN_RVW=[0], then M2003_MDCTN_FLWP must equal [^].
// N-skip pattern-4431 If M2001_DRUG_RGMN_RVW=[1], then all active items from M2003_MDCTN_FLWP through M2030_CRNT_MGMT_INJCTN_MDCTN must not equal [^].
// N-skip pattern-4441 If M2001_DRUG_RGMN_RVW=[9], then all active items from M2003_MDCTN_FLWP through M2030_CRNT_MGMT_INJCTN_MDCTN must equal [^].
// N-skip pattern-5490 If M2001_DRUG_RGMN_RVW=[0], then M2010_HIGH_RISK_DRUG_EDCTN must not equal [^].
// N-skip pattern-5960
// (a) If N0415A1=[0], then N0415A2 must equal [^].
// (b) If N0415A1=[1], then N0415A2 must not equal [^].
// N-skip pattern-5970
// (a) If N0415E1=[0], then N0415E2 must equal [^].
// (b) If N0415E1=[1], then N0415E2 must not equal [^].
// N-skip pattern-5980
// (a) If N0415F1=[0], then N0415F2 must equal [^].
// (b) If N0415F1=[1], then N0415F2 must not equal [^].
// N-skip pattern-5990
// (a) If N0415H1=[0], then N0415H2 must equal [^].
// (b) If N0415H1=[1], then N0415H2 must not equal [^].
// N-skip pattern-6000
// (a) If N0415I1=[0], then N0415I2 must equal [^].
// (b) If N0415I1=[1], then N0415I2 must not equal [^].
// N-skip pattern-6010
// (a) If N0415J1=[0], then N0415J2 must equal [^].
// (b) If N0415J1=[1], then N0415J2 must not equal [^].
